import { HttpStatusCode } from "@angular/common/http";
import { Injectable, Input } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MessageType } from "../enums/message-type";
import { TranslateService } from "@ngx-translate/core";
import { AdministrationResultStatus, SecurityResultStatus } from "../clients/system-api/SystemApiClient";

@Injectable({
    providedIn: 'root'
})

export class SnackBarService {

    state: any
    messageMap = {
        [Number(HttpStatusCode.Unauthorized)]: { type: MessageType.Error, message: "Session ended, log in again!", },
        [Number(HttpStatusCode.Forbidden)]: { type: MessageType.Error, message: "You do not have access privileges!", },
    }

    constructor(
        private _snackBar: MatSnackBar,
        public translate: TranslateService
    ) { }

    callSnackBar(next: any, source?: any) {
        if (next == null || next == undefined) {
            // wtf why...
            this._snackBar.open(this.translate.instant("Грешка:  Status: " + next), 'Close', {
                duration: 5000,
                panelClass: ['red-snackbar', 'no-close-button'],
            });
        }
        else {
            if (next.status == undefined || next.status == null) {
                this.state = next;
            }
            else {
                this.state = next.status;
            }
        }

        var messageData = this.messageMap[this.state];

        if (messageData != undefined) {
            var classType = "green-snackbar";
            if (messageData.type == MessageType.Error) {
                classType = "red-snackbar";
            }
            this._snackBar.open(this.translate.instant(messageData.message), 'Close', {
                duration: 5000,
                panelClass: [classType]
            });
        }
        else
            if (this.state == AdministrationResultStatus.Success || this.state == SecurityResultStatus.Success) {
                if (source == "Login") {
                    this._snackBar.open(this.translate.instant("Successfully login"), 'Close', {
                        duration: 5000,
                         panelClass: ['green-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                    });
                }
                else if (source == "Logout") {
                    this._snackBar.open(this.translate.instant("Successfully logout"), 'Close', {
                        duration: 5000,
                         panelClass: ['green-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                    });
                }
                else if (source == "Change Password") {
                    this._snackBar.open(this.translate.instant("Successfully change password"), 'Close', {
                        duration: 5000,
                         panelClass: ['green-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                    });
                }
                else if (source == "Successfully entered") {
                    this._snackBar.open(this.translate.instant("Successfully entered"), 'Close', {
                        duration: 5000,
                         panelClass: ['green-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                    });
                }
                else if (source == "Successfully send") {
                    this._snackBar.open(this.translate.instant("Successfully send"), 'Close', {
                        duration: 5000,
                         panelClass: ['green-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                    });
                }
                else if (source == "Successfully deleted") {
                    this._snackBar.open(this.translate.instant("Successfully deleted"), 'Close', {
                        duration: 5000,
                         panelClass: ['green-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                    });
                }
                else if (source == "Successfully canceled") {
                    this._snackBar.open(this.translate.instant("Successfully canceled"), 'Close', {
                        duration: 5000,
                         panelClass: ['green-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                    });
                }
                else if (source == "EmailVerificationCode") {
                    this._snackBar.open(this.translate.instant("EmailVerificationCode"), 'Close', {
                        duration: 5000,
                         panelClass: ['green-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                    });
                }
                else if (source == "ServiceCategoryAddSuccess") {
                  this._snackBar.open(this.translate.instant("Category added successfully"), 'Close', {
                    duration: 5000,
                    panelClass: ['green-snackbar'],
                    horizontalPosition: 'center',
                    verticalPosition:'top'
                  });
                }
                else if (source == "ServiceCategoryEditSuccess") {
                    this._snackBar.open(this.translate.instant('generic submit success'), 'Close', {
                        duration: 5000,
                        panelClass: ['green-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                    });
                }
                else if (source == "ServiceCategoryЕditFail") {
                  this._snackBar.open(this.translate.instant("generic error"), 'Close', {
                    duration: 5000,
                    panelClass: ['red-snackbar'],
                    horizontalPosition: 'center',
                    verticalPosition:'top',
                  });
                }
                else if (source == "ServiceCategoryAddFail") {
                  this._snackBar.open(this.translate.instant("generic error"), 'Close', {
                    duration: 5000,
                    panelClass: ['red-snackbar'],
                    horizontalPosition: 'center',
                    verticalPosition:'top'
                  });
                }
                else if (source == "UserAddSuccess") {
                  this._snackBar.open(this.translate.instant("User added successfully"), 'Close', {
                    duration: 5000,
                    panelClass: ['green-snackbar'],
                    horizontalPosition: 'center',
                    verticalPosition:'top'
                  });
                }
                else if (source == "UserEditSuccess") {
                  this._snackBar.open(this.translate.instant("generic submit success"), 'Close', {
                    duration: 5000,
                    panelClass: ['green-snackbar'],
                    horizontalPosition: 'center',
                    verticalPosition:'top'
                  });
                }
                else if (source == "UserEditFail") {
                  this._snackBar.open(this.translate.instant("generic error"), 'Close', {
                    duration: 5000,
                    panelClass: ['red-snackbar'],
                    horizontalPosition: 'center',
                    verticalPosition:'top',
                  });
                }
                else if (source == "UserAddFail") {
                  this._snackBar.open(this.translate.instant("generic error"), 'Close', {
                    duration: 5000,
                    panelClass: ['red-snackbar'],
                    horizontalPosition: 'center',
                    verticalPosition:'top'
                  });
                }
                else if (source == "RetrieveFail") {
                  this._snackBar.open(this.translate.instant("generic try again"), 'Close', {
                    duration: 5000,
                    panelClass: ['red-snackbar'],
                    horizontalPosition: 'center',
                    verticalPosition:'top',
                  });
                }
                else if (source == "DontShowSuccess") { }
                else {
                    this._snackBar.open(this.translate.instant("Successfully saved"), 'Close', {
                        duration: 5000,
                         panelClass: ['green-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                    });
                }
            }
            else if (this.state == AdministrationResultStatus.EmployeeNotAvailable) {
                this._snackBar.open(this.translate.instant("Employee not avilable"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == AdministrationResultStatus.OverlappingTimeSlots) {
                this._snackBar.open(this.translate.instant("Overlapping Time Slots"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == AdministrationResultStatus.OverlapingTerms) {
                this._snackBar.open(this.translate.instant("Overlaping Terms"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == AdministrationResultStatus.ServerError) {
                this._snackBar.open(this.translate.instant("Server Error"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == AdministrationResultStatus.InvalidConfiguration) {
                this._snackBar.open(this.translate.instant("Invalid configuration, please try again"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == AdministrationResultStatus.WrongCreditials) {
                this._snackBar.open(this.translate.instant("You entered an incorrect password"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == SecurityResultStatus.InvalidUser) {
                this._snackBar.open(this.translate.instant("You entered an incorrect username or password"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == SecurityResultStatus.InvalidToken) {
                this._snackBar.open(this.translate.instant("Invalid token, please try again"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == SecurityResultStatus.InvalidVerificationCode) {
                this._snackBar.open(this.translate.instant("Invalid verification code, please try again"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == AdministrationResultStatus.InvalidDate) {
                this._snackBar.open(this.translate.instant("Invalid date, please select another"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == AdministrationResultStatus.ArgumentsException) {
                this._snackBar.open(this.translate.instant("Invalid input, try again"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == AdministrationResultStatus.NotFound) {
                this._snackBar.open(this.translate.instant("No required data found"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == AdministrationResultStatus.UserNotValidated) {
                this._snackBar.open(this.translate.instant("User not validated"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == AdministrationResultStatus.RecordAlreadyExists) {
                this._snackBar.open(this.translate.instant("Record already exists"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == AdministrationResultStatus.Error) {
                this._snackBar.open(this.translate.instant("Error"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == AdministrationResultStatus.NotAuthenticated) {
                this._snackBar.open(this.translate.instant("The user is not authenticated"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == AdministrationResultStatus.AlreadyCancelled) {
                this._snackBar.open(this.translate.instant("Term already cancelled"), 'Close', {
                    duration: 5000,
                     panelClass: ['green-snackbar'],
                       horizontalPosition: 'center',
                       verticalPosition:'top'
                });
            }
            else if (this.state == AdministrationResultStatus.NoTerms) {
                this._snackBar.open(this.translate.instant("No terms"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == "ConfirmPasswordError") {
                this._snackBar.open(this.translate.instant("New password confirmation is wrong"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == "MissingDocuments") {
                this._snackBar.open(this.translate.instant("You must attach at least one document"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else if (this.state == "Error") {
                this._snackBar.open(this.translate.instant("Error"), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
            else {
                this._snackBar.open(this.translate.instant("Error: " + next + " Status: " + next.status), 'Close', {
                    duration: 5000,
                     panelClass: ['red-snackbar'],
                        horizontalPosition: 'center',
                        verticalPosition:'top'
                });
            }
    }
}
